var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNibbleFavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 23,
    fill: "#B542FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1322 59.5427C80.7343 59.5427 84.4651 56.0859 84.4651 51.8218C84.4651 47.5576 80.7343 44.1008 76.1322 44.1008C71.5301 44.1008 67.7993 47.5576 67.7993 51.8218C67.7993 56.0859 71.5301 59.5427 76.1322 59.5427Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.122 28.741V27.6279C56.122 26.3743 55.6288 25.2847 54.6425 24.3708C53.6562 23.457 52.4803 23.0001 51.121 23.0001H39.001C37.6417 22.9942 36.4657 23.4511 35.4794 24.365C34.4931 25.2788 34 26.3684 34 27.6279V99.0319C34 100.291 34.4931 101.375 35.4794 102.295C36.4657 103.209 37.6417 103.666 39.001 103.666H49.0535L68.8046 125.258C72.8193 128.978 79.3566 128.902 83.2702 125.094L102.939 103.666L111.999 103.478C113.352 103.478 114.528 103.021 115.514 102.107C116.501 101.194 117 100.104 117 98.8444V54.7508C117 29.69 83.4978 15.9587 56.122 28.741ZM76.1322 37.4109C90.2754 37.4109 102.225 45.8524 106.075 57.4338L90.6168 64.5982C85.9445 66.7598 85.9445 72.9342 90.6168 75.0958L103.944 81.2702C97.9001 95.9213 85.4388 108.715 79.4641 114.292C77.6306 116.009 74.6402 116.014 72.8004 114.292C64.752 106.77 44.8745 86.1207 44.8745 65.4827C44.8745 49.9764 58.8659 37.405 76.1259 37.405L76.1322 37.4109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNibbleFavicon);
export default __webpack_public_path__ + "static/media/nibble-favicon.b30c2c59d001715558dd640933fa56db.svg";
export { ForwardRef as ReactComponent };